import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import { Body } from "capitalrx-components-2.0/lib/typography";

import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared";

import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */
export interface PlaceholderProps extends BaseProps {
  /**
   * Indicates whether the input has instructions. If not specified defaults to `false`.
   */
  readonly hasInstructions?: boolean;
}

/**
 * A loading placeholder for the `Textbox` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { hasInstructions = false } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.FileUploadPlaceholder, "file-upload", "placeholder"],
    testIdPrefix: "file-upload",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)} hasInstructions={hasInstructions}>
      <Body className="input-container" aria-hidden="true">
        <Skeleton />
      </Body>
    </InputContainerPlaceholder>
  );
};
